import { Validator } from '@vista-digital/validator';
import { seatPositionValidator } from '../seating/seat-position';
import { nonEmptyStringValidator } from '../string';
import { translatableValidator } from '../translatable';
export const orderSeatValidator = Validator.object({
    seatId: nonEmptyStringValidator,
    seatLabel: Validator.optional(nonEmptyStringValidator),
    rowLabel: nonEmptyStringValidator,
    position: seatPositionValidator,
    areaCategoryId: nonEmptyStringValidator,
    areaName: translatableValidator
});
